'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useComponentBoundingBox } from '../../util/use-component-bounding-box.js';
import { useMediaQuery, Breakpoints } from '../../util/use-media-query.js';
import { Nav } from '../nav/nav.js';
import '../nav/header-entry.js';
import 'next/link.js';
import 'react';
import '../../util/formatters/format-date.js';
import 'date-fns';
import 'date-fns/locale';
import '../../util/datetime/constants.js';
import '../../util/datetime/comparators.js';
import '../../types/order.js';
import '../../types/category.js';
import '../button/button.js';
import '../button/constants.js';
import 'lodash.isempty';
import 'lodash.isnil';
import 'lodash.omitby';
import '../../util/font.js';
import { MobileSidebarProvider } from '../nav/mobile/mobile-sidebar-provider.js';
import { SubNav } from '../subnav/subnav.js';

const PageHeader = ({ navProps, subNavProps, sticky, }) => {
    const isSm = useMediaQuery(Breakpoints.SM);
    const [navRef, navSize] = useComponentBoundingBox();
    return (jsxs(MobileSidebarProvider, { children: [sticky ? (jsx("div", { className: "shrink-0", style: {
                    height: 
                    // use exact size once known
                    navSize?.height ??
                        // harcoded sizes are from observed values + height classNames of `Nav`
                        (isSm
                            ? subNavProps
                                ? 133
                                : 80
                            : navProps.searchBarProps
                                ? 144
                                : 80),
                }, children: "\u00A0" })) : null, jsxs("div", { ref: navRef, className: `${sticky ? 'fixed inset-x-0 top-0' : 'relative'} flex flex-col-reverse`, children: [isSm && subNavProps ? jsx(SubNav, { ...subNavProps }) : null, jsx(Nav, { ...navProps })] })] }));
};

export { PageHeader };
//# sourceMappingURL=page-header.js.map
